import React from "react";
import { ValidatedTopMenuItem } from "../../utils";
import * as styles from "./TopNavLink.module.scss";
import { Icon, IconName } from "@silversea-ssc/ui-components-react";
import { match } from "ts-pattern";
import clsx from "clsx";

type TopNavLinkProps = Omit<ValidatedTopMenuItem, "href" | "openNewTab"> & {
  iconName?: IconName;
  iconStrokeWidth?: number;
} & (
    | (React.ButtonHTMLAttributes<HTMLButtonElement> & {
        renderAs: "button";
      })
    | (React.AnchorHTMLAttributes<HTMLAnchorElement> & {
        renderAs: "link";
        openNewTab: boolean;
      })
  );

const TopNavLink: React.FC<TopNavLinkProps> = ({
  title,
  specialType,
  trackingName,
  iconName,
  children,
  className,
  iconStrokeWidth,
  ...props
}) => {
  const commonProps = {
    className: clsx(styles.topNavItem, className),
    "data-navlink-id": specialType,
    "data-content-piece": trackingName
  };
  const combinedChildren = (
    <>
      {title}
      {iconName && (
        <>
          {" "}
          <Icon
            name={iconName}
            padding={false}
            size="1x"
            strokeWidth={iconStrokeWidth || 0}
          />
        </>
      )}
      {children}
    </>
  );

  return match(props)
    .with({ renderAs: "button" }, ({ renderAs, ...props }) => (
      <button {...commonProps} {...props}>
        {combinedChildren}
      </button>
    ))
    .with({ renderAs: "link" }, ({ renderAs, openNewTab, ...props }) => (
      <a
        {...commonProps}
        target={openNewTab ? "_blank" : undefined}
        rel="noreferrer"
        {...props}
      >
        {combinedChildren}
      </a>
    ))
    .exhaustive();
};

export default React.memo(TopNavLink);
